module.exports = {"data":{"allThirdPartyWorldCupMatches":{"edges":[{"node":{"home_team":{"code":"RSA"},"away_team":{"code":"CHN"},"venue":"Paris","datetime":"2019-06-13T19:00:00Z","stage_name":"First Stage","status":"in progress"}},{"node":{"home_team":{"code":"JPN"},"away_team":{"code":"SCO"},"venue":"Rennes","datetime":"2019-06-14T13:00:00Z","stage_name":"First Stage","status":"future"}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/actualday.json
// module id = 315
// module chunks = 26558195579783